import { SWRConfiguration } from 'swr';

import { EmployeeEquipmentType } from '~/data/equipment/types';
import { UseArraySWROutput, useArraySWR } from '~/hooks/useSWR';
import { fetchFromOldApi } from '~/services/Http';

export const saveEmployeeEquipment = async (
  employeeId: number,
  equipmentId: number | undefined,
  submissionData: FormData,
  isNewCompanyEquipment: boolean,
): Promise<EmployeeEquipmentType> => {
  const type = submissionData instanceof FormData ? 'form' : 'json';

  const method = typeof equipmentId === 'undefined' ? 'POST' : 'PUT';
  const requestUrl =
    method === 'PUT'
      ? `/form/employee/${employeeId}/equipment/${equipmentId}`
      : `/${type}${
          isNewCompanyEquipment ? '/company' : ''
        }/employee/${employeeId}/equipment`;

  return await fetchFromOldApi(requestUrl, {
    method,
    ...(type === 'json' && {
      headers: { 'Content-Type': 'application/json' },
    }),
    body:
      type === 'json'
        ? JSON.stringify(submissionData)
        : (submissionData as FormData),
  }).then((r) => r.json());
};

export const deleteEquipment = async (
  employeeId: number,
  equipmentId: number,
) => {
  return await fetchFromOldApi(
    `/json/employee/${employeeId}/equipment/${equipmentId}`,
    {
      method: 'DELETE',
    },
  ).then((r) => r.json());
};

export const getEmployeeEquipment = async (
  employeeId: number,
): Promise<EmployeeEquipmentType[]> => {
  return fetchFromOldApi(`/json/employee/${employeeId}/equipment`).then((r) =>
    r.json(),
  );
};

type PropsType = {
  employeeId?: number;
};

export const useGetEmployeeEquipment = (
  props: PropsType,
  swrConfig?: SWRConfiguration<EmployeeEquipmentType[]>,
  isDisabled?: boolean,
): UseArraySWROutput<EmployeeEquipmentType> => {
  const { employeeId } = props;

  return useArraySWR(
    !isDisabled && !!employeeId ? ['getEmployeeEquipment', employeeId] : null,
    ([_key, employeeId]: [string, number]) =>
      getEmployeeEquipment(employeeId).then((data) =>
        data.sort((a: EmployeeEquipmentType, b: EmployeeEquipmentType) => {
          return (
            new Date(b.fEquipmentDeliveryDate).valueOf() -
            new Date(a.fEquipmentDeliveryDate).valueOf()
          );
        }),
      ),
    swrConfig,
  );
};
